import React from "react";
import Create from "modules/currencies/components/Create";

const CurrenciesCreatePage = () => {
  return <Create />;
};

export default CurrenciesCreatePage;
